import React from 'react'
import { Tabs } from '@surecompanies/core_components'
import styles from './PlanOverridesComponents.module.scss'

const { TabPane } = Tabs

export interface SubTabItem<T extends string> {
  key: T
  label: string
  count?: number
}

interface Props<T extends string> {
  items: SubTabItem<T>[]
  activeKey: T
  onChange: (key: T) => void
}

export default function StatusSubTabs<T extends string>({
  items,
  activeKey,
  onChange,
}: Props<T>) {
  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => onChange(key as T)}
      type="line"
      tabBarStyle={{ marginBottom: 0 }}
    >
      {items.map((item) => (
        <TabPane
          tab={
            <span>
              {item.label}
              {typeof item.count === 'number' && (
                <span className={styles.count}>({item.count})</span>
              )}
            </span>
          }
          key={item.key}
        />
      ))}
    </Tabs>
  )
}
